import React from "react";
import { FiExternalLink } from "react-icons/fi";

const FALLBACK_LOGO = "/img/partenaire-placeholder.png";

const toAbsolutePhotoUrl = (photo_url) => {
  if (!photo_url) return "";
  if (photo_url.startsWith("http")) return photo_url;

  const base = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const clean = String(photo_url).replaceAll("\\", "/").replace(/^\/+/, "");
  return `${base}/${clean}`;
};

export default function CompetitionPartnersSection({ partenaires = [], loading = false }) {
  if (loading) {
    return (
      <div className="rounded-2xl border border-gray-200/70 dark:border-slate-700/70 bg-white/70 dark:bg-slate-800/60 p-4">
        <div className="h-4 w-40 bg-gray-200/70 dark:bg-slate-700/70 rounded mb-3 animate-pulse" />
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-24 rounded-xl bg-gray-200/70 dark:bg-slate-700/70 animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  if (!partenaires?.length) return null;

  return (
    <section className="rounded-2xl border border-gray-200/70 dark:border-slate-700/70 bg-white/80 dark:bg-slate-800/70 backdrop-blur shadow-sm overflow-hidden">
      <div className="p-4 border-b border-gray-200/70 dark:border-slate-700/70">
        <h4 className="font-semibold text-gray-900 dark:text-white">Merci à nos Partenaires</h4>
        <p className="text-xs text-gray-600 dark:text-gray-300 mt-1">
          Cliquez pour visiter le site du partenaire.
        </p>
      </div>

      <div className="p-4 grid grid-cols-2 sm:grid-cols-3 gap-3">
        {partenaires.map((p) => {
          const logo = toAbsolutePhotoUrl(p.photo_url) || FALLBACK_LOGO;
          const href = (p.link_url || "").trim();
          const clickable = !!href;

          return (
            <a
              key={p.id}
              href={clickable ? href : undefined}
              target={clickable ? "_blank" : undefined}
              rel={clickable ? "noreferrer" : undefined}
              className={
                "group rounded-xl border border-gray-200/70 dark:border-slate-700/70 bg-white/70 dark:bg-slate-900/50 p-3 hover:bg-white dark:hover:bg-slate-800/70 transition " +
                (clickable ? "cursor-pointer" : "cursor-default opacity-80")
              }
              onClick={(e) => {
                if (!clickable) e.preventDefault();
              }}
              title={clickable ? "Ouvrir dans un nouvel onglet" : "Aucun lien renseigné"}
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg overflow-hidden bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
                  <img
                    src={logo}
                    alt={p.nom}
                    className="w-full h-full object-cover"
                    onError={(e) => (e.currentTarget.src = FALLBACK_LOGO)}
                  />
                </div>

                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-sm text-gray-900 dark:text-white truncate">
                    {p.nom}
                  </div>
                  <div className="text-[11px] text-gray-500 dark:text-gray-400 truncate">
                    {href || "Lien non renseigné"}
                  </div>
                </div>

                {clickable && (
                  <FiExternalLink className="opacity-0 group-hover:opacity-100 transition text-gray-600 dark:text-gray-300" />
                )}
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}
